
export const headerData = {
    name: 'AKHIL JP',
    title: "Hello! I am",
    desciption: "Welcome to my profile!!!  Sub Engineer from Kerala. I'm Akhil Prakash, working with Kerala State Electricity Board.",
    image: 'https://images.unsplash.com/photo-1688934132625-412637384e80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=533&q=80',
    imagebw: 'https://images.unsplash.com/photo-1688934132556-d4a5ff01c537?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=584&q=80',
    resumePdf: 'https://drive.google.com/file/d/1AU-RqKLrM5mMXzKPt69mDhchfq7vJd9u/view?usp=sharing'
}
